module.exports = __webpack_public_path__ + "static/media/pdf-icon.4f6babf8.svg";